<!--
 * @Author: zhonghao
 * @Date: 2023-05-04 17:42:28
-->
<template>
  <div class="live-swipe" v-if="imageList && imageList.length > 0">
    <van-swipe indicator-color="#EB1700" autoplay="2000">
      <van-swipe-item v-for="image in imageList" :key="image.id" v-track="{ functionName: image.title }"
        @click="liveClick(image)">
        <img :src="getImage(image)" :alt="image.title" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { getUserIdentity, setSha, traceClickURL } from '../../../utils/util'
import { isScorm } from '../../../api/scorm'
import qs from 'qs'

export default {
  name: 'home-banner',
  props: {
    imageList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      userIdentity: getUserIdentity(),
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    getImage() {
      return (image) => {
        if (image.pictureMaterial && image.pictureMaterial.url) {
          return image.pictureMaterial.url
        } else if (image.pictureUrl) {
          return image.pictureUrl
        } else {
          return ''
        }
      }
    }
  },
  methods: {
    async liveClick(item) {
      const { linkUrl } = item
      const hasKeyword = (keyword) => linkUrl.includes(keyword)

      if (hasKeyword('contest')) {
        // 员工不能参加竞赛（memberType === 0 表示术者）
        if (this.userInfo.memberType !== 0) {
          this.$tipsDialog.alert({
            message: '仅术者可参加竞赛',
            confirmButtonText: '我知道了',
            // decorationImage: require('@/assets/images/decorationImage.png'),
          })
          return
        }
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}${linkUrl}`)
        this.$router.push({ path: linkUrl })
        return
      }

      if (hasKeyword('annualReport')) {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}${linkUrl}`)
        this.$router.push({ path: linkUrl })
        return
      }

      if (hasKeyword('articleDetails') || hasKeyword('dccDetail') || hasKeyword('topicDetail')) {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}${linkUrl}`)
        this.$router.push({ path: linkUrl })
        return
      }

      if (hasKeyword('courserDetails')) {
        window.sessionStorage.setItem('entrance', '10')
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}${linkUrl}`)
        const urlParamsStr = linkUrl.split('?')[1] || ''
        const urlParams = qs.parse(urlParamsStr)

        const query = {
          entrance: urlParams.entrance || '',
          channel: urlParams.channel || '',
        }

        // 添加 courseId 参数
        if (urlParams.courseId) query.courseId = urlParams.courseId

        // 判断是否为 SCORM 课程
        const courseId = urlParams.courseId || ''
        let path = '/courserDetails'
        try {
          const { data } = await isScorm(courseId)
          if (data) path = '/scormCourseDetail'
        } catch (e) {
          console.error('isScorm 调用失败:', e)
        }

        this.$router.push({ path, query })
        return
      }

      if (hasKeyword('database')) {
        this.$router.push({ path: linkUrl })
        return
      }

      if (hasKeyword('pfa')) {
        this.$router.push({ path: linkUrl })
        return
      }

      if (hasKeyword('/simulator/caseDownloadLibrary')) {
        this.$router.push({ path: linkUrl })
        return
      }

      if (hasKeyword('kdSimulator')) {
        const { veevaStatus, isDueDate } = this.userIdentity
        if (veevaStatus === '待验证' && isDueDate) {
          this.$emit('cDialog', {
            visible: true,
            title: '提示',
            content: '敬请期待!',
          })
          return
        }
      }

      if (item.linkUrl.indexOf('casesharing') > -1) {
        let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(
          `xxbiep${this.userInfo.iepOpenId}`
        )}`
        let url = `${item.linkUrl}${openidBindli}`
        localStorage.setItem('functionUrl', item.linkUrl)
        setTimeout(() => {
          traceClickURL()
        })
        window.location.href = url
        return
      }

      // 病例评鉴
      if (hasKeyword('caseReview')) {
        this.$router.push({ path: linkUrl })
        return
      }

      window.location.href = linkUrl
    }
  },
}
</script>

<style lang="less" scoped>
.live-swipe {
  // margin: 12px;
  width: 351px;
  height: 158px;
  position: absolute;
  bottom: 100px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 2px 3px 13px 0px rgba(0, 0, 0, 0.14);
  border-radius: 12px;
}
</style>
<style lang="less" scoped>
/deep/ .van-swipe {
  border-radius: 12px;
}

/deep/ .van-swipe__indicators {
  bottom: 10px;
}

/deep/ .van-swipe__indicator:not(:last-child) {
  margin-right: 3px;
}

img {
  width: 351px;
  height: 158px;
  border-radius: 12px;
  object-fit: cover;
}

/deep/ .van-swipe__track {
  border-radius: 12px;
  height: 158px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/HomeBanner.vue